import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { getPrettyDate } from "../../../../utils/timestamp";

import { NHITypeIconsAndLabels } from "../utils";

export const getNHIColumns = (colors, showLocalTime) => ({
  type: {
    field: "type",
    headerName: "Type",
    minWidth: 165,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    resizable: false,
    valueGetter: (params) => params.row.subtype || null,
    valueFormatter: (params) => {
      if (!params.value) return null;
      if (!NHITypeIconsAndLabels[params.value]) return params.value;
      const [, label] = NHITypeIconsAndLabels[params.value];
      return label;
    },
    renderCell: (params) => {
      if (!params.value) return "-";

      if (!NHITypeIconsAndLabels[params.value]) {
        return (
          <Box display="flex" alignItems="center">
            <Typography variant="caption" color={colors.grey_700}>
              {params.value}
            </Typography>
          </Box>
        );
      }

      const [Icon, label] = NHITypeIconsAndLabels[params.value];
      return (
        <Box display="flex" alignItems="center" gap={1}>
          <SvgToIcon IconLogo={Icon} width={"24px"} />
          <Typography variant="caption" color={colors.grey_700}>
            {label}
          </Typography>
        </Box>
      );
    },
  },
  lastUsed: {
    field: "last_used",
    headerName: "Last Used",
    minWidth: 120,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    resizable: false,
    valueGetter: (params) => {
      if (params.row?.okta_token_data?.last_updated_datetime)
        return params.row.okta_token_data?.last_updated_datetime.timestamp_utc;
      if (params.row?.aws_secret_data?.last_changed_datetime)
        return params.row.aws_secret_data?.last_changed_datetime.timestamp_utc;
      if (params.row?.azure_keyvault_resource_data?.last_updated_date)
        return params.row.azure_keyvault_resource_data.last_updated_date;
      if (params.row?.atlassian_api_key_data?.last_active_at)
        return params.row.atlassian_api_key_data?.last_active_at.timestamp_utc;
      if (params.row?.atlassian_api_token_data?.last_active_at)
        return params.row.atlassian_api_token_data?.last_active_at
          .timestamp_utc;
      if (params.row?.github_pat_data?.last_used_at)
        return params.row.github_pat_data?.last_used_at.timestamp_utc;
      if (params.row?.github_secret_data?.last_updated_date)
        return params.row.github_secret_data?.last_updated_date.timestamp_utc;
      if (params.row?.zendesk_api_token_data?.last_used)
        return params.row.zendesk_api_token_data?.last_used.timestamp_utc;
      if (params.row?.gitlab_access_token_data?.last_used_at)
        return params.row.gitlab_access_token_data.last_used_at.timestamp_utc;
      if (
        params.row?.salesforce_oauth_token_data?.last_used_date?.timestamp_utc
      )
        return params.row.salesforce_oauth_token_data.last_used_date
          .timestamp_utc;
      if (params.row?.openai_admin_api_key_data?.last_used_at)
        return params.row.openai_admin_api_key_data.last_used_at.timestamp_utc;
      return null;
    },
    valueFormatter: (params) =>
      params.value > 0 ? getPrettyDate(params.value, showLocalTime) : null,
    renderCell: (params) =>
      params.value > 0 ? (
        <Typography variant="caption" color={colors.grey_700}>
          {getPrettyDate(params.value, showLocalTime)}
        </Typography>
      ) : (
        "-"
      ),
  },
  expirationDate: {
    field: "expiration_date",
    headerName: "Expiration Date",
    minWidth: 160,
    flex: 0.5,
    align: "left",
    headerAlign: "left",
    disableReorder: true,
    resizable: false,
    valueGetter: (params) => {
      if (params.row?.okta_token_data?.expiration_datetime?.timestamp_utc)
        return params.row.okta_token_data?.expiration_datetime.timestamp_utc;
      if (
        params.row?.azure_keyvault_resource_data?.expiration_date?.timestamp_utc
      )
        return params.row.azure_keyvault_resource_data.expiration_date
          .timestamp_utc;
      if (params.row?.atlassian_api_key_data?.expires_at)
        return params.row.atlassian_api_key_data?.expires_at.timestamp_utc;
      if (params.row?.atlassian_api_token_data?.expires_at)
        return params.row.atlassian_api_token_data?.expires_at.timestamp_utc;
      if (params.row?.github_pat_data?.expired_date)
        return params.row.github_pat_data?.expired_date.timestamp_utc;
      if (params.row?.microsoft_entra_id_application_data?.expiration_date)
        return params.row.microsoft_entra_id_application_data?.expiration_date
          .timestamp_utc;
      if (params.row?.gitlab_access_token_data?.expires_at)
        return params.row.gitlab_access_token_data?.expires_at.timestamp_utc;
      return null;
    },
    valueFormatter: (params) =>
      params.value > 0 ? getPrettyDate(params.value, showLocalTime) : null,
    renderCell: (params) =>
      params.value > 0 ? (
        <Typography variant="caption" color={colors.grey_700}>
          {getPrettyDate(params.value, showLocalTime)}
        </Typography>
      ) : (
        "-"
      ),
  },
});
